import { Formik, setIn, useFormikContext } from 'formik'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import '../../App.css'
import signupImg from '../../images/signup_bg.png'
import isoLogo from '../../images/iso_logo.svg'
import isoMob from '../../images/iso_logo.svg'
import customerLogo from '../../images/header_customer_banner.svg'
import customerLogoMob from '../../images/header_customer_banner_mobile.svg'
import capterraLogo from '../../images/capterra_logo.svg'
import g2Logo from '../../images/g2_logo.svg'
import starImage from '../../images/star.svg'
import logo from '../../images/wa_logo.svg'
import loader from '../../images/popup_loading.svg'
import * as R from 'ramda'
import axios from 'axios'
import { useCombobox, useSelect } from 'downshift'
import countryCodes from './country_codes'
import { Link, useLocation } from 'react-router-dom'
import {
    BLOCKED_EMAIL,
    signupFormSchema,
    WS_CHECK_FAILURE,
    EXISTING_EMAIL_CHECK_FAILED,
} from './signup-form-validation'
import {
    DropdownWrapper,
    InputContainer,
    InputWrapper,
    Input,
    InputContent,
    CancelButton,
    InputErrorIcon,
    ErrorMessage,
    IconRight,
    DropdownUlWrapper,
    DropdownUl,
    DropdownLi,
    RightDropdownArrow,
    FormWrapper,
    WorkspaceName,
    WidthContainer,
    PasswordWrapper,
    PasswordIcon,
    InformationIcon,
    MobileWrapper,
    MobileWrapperLeft,
    Paragraph,
    SignInWrapper,
    Button,
    PopupLoader,
    ContentWrapper,
    HeaderContent,
    UlWrapper,
    LiContent,
    GridContainer,
    GridContainerMobile,
    MobileContentWrapper,
    MobileHeaderContentWrapper,
    ImageWrapper,
    Logo,
    Wrapper,
    BgImage,
    ChannelIcons,
    LogosHeader,
    IsoLogo,
    MobileOverlay,
    MobileOverlayContent,
    ThankyouWrapper,
    ThankyouImageWrapper,
    ContentWithPadding,
    CustomerLogoDiv,
    TestimonialsDiv,
    FirstReview,
    SecondReview,
    TestimonialsDivMobile,
    FirstReviewMobile,
    SecondReviewMobile,
    MobileCodeWrapper,
} from './signup-styled-components'
import {
    ErrorIcon,
    UserIcon,
    DropdownIcon,
    NextIcon,
    EmailICon,
    PasswordIcons,
    PasswordHideIcon,
    GreenTickIconMarketplace,
    WorkspaceIcon,
    CompanyIcon,
    EmployeeSizeIcon,
    MobileIcon,
    TeamsIcon,
    WidgetIcon,
    SlackIconCC,
    ThumbsUpSvg,
    InfoIcon,
    CountryIcon,
} from './signup-page-icons'
import { useMedia } from '../common/use-media'
import { lazyGA } from '../../ga'
import {
    findFlagByDialCode,
    getList,
    searchFlag,
} from 'country-list-with-dial-code-and-flag'
import mixpanel from 'mixpanel-browser'
import Turnstile from './capthca'
function sleeper(ms) {
    return function(x) {
        return new Promise(resolve => setTimeout(() => resolve(x), ms))
    }
}

// console.log("Turnstile", Turnstile)

// function sleeper(ms) {
//     return function (x) {
//         return new Promise(resolve => setTimeout(() => resolve(x), ms));
//     };
// }
const getUtmParams = ()=> {
    const params = new URLSearchParams(window.location.search)
    // console.log("DOING ::: BEFORE UTM PARAMS",url)
    let utmParams = {};
for (const [key, val] of params) {
  // check for prefix
    console.log("DOING ::: BEFORE UTM PARAMS",key,val)
  if (key.startsWith('utm_')) {
    // add to a new object array
    utmParams[key] = val;
  }
}
    return utmParams
}
const CommonInputs = ({
    type,
    placeholder,
    inputIcon,
    name,
    showIcon,
    errorText: _errorText,
    canShowErr: _canShowErr,
    transform = R.identity,
    showInfoIcon,
}) => {
    const {
        values,
        errors,
        handleBlur,
        touched,
        setFieldValue,
    } = useFormikContext()

    const setFieldValueForName = R.curry(R.binary(setFieldValue))(name)
    const transformValue = R.compose(
        transform,
        R.prop('value')
    )
    const transformAndSet = R.compose(
        setFieldValueForName,
        transformValue
    )
    const handleChange = R.compose(
        transformAndSet,
        R.prop('target')
    )

    const canShowErr = _canShowErr || (() => touched[name] && errors[name])

    const errorText = _errorText || (() => errors[name])

    return (
        <DropdownWrapper>
            <InputContainer>
                <InputWrapper>
                    <Input
                        primary
                        type={type}
                        value={values[name]}
                        name={name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        autoComplete="false"
                    />
                    <InputContent primary>
                        {placeholder}
                        {showInfoIcon && (
                            <InformationIcon>
                                <span
                                    tooltip="Password should be minimum 8 characters long and combination of alpha, numeric, uppercase, lowercase with special characters."
                                    flow="up"
                                    //className="first-span"
                                >
                                    <InfoIcon />
                                </span>
                            </InformationIcon>
                        )}
                    </InputContent>
                    {showIcon && <CancelButton>{inputIcon}</CancelButton>}
                    {canShowErr(touched[name], errors[name]) && (
                        <>
                            <InputErrorIcon>
                                <ErrorIcon />
                            </InputErrorIcon>
                            <ErrorMessage>
                                {errorText(errors[name])}
                            </ErrorMessage>
                        </>
                    )}
                </InputWrapper>
            </InputContainer>
        </DropdownWrapper>
    )
}

const CompanySizeDropdown = ({ header, name }) => {
    const options = [
        'Below 500',
        '500 - 1000',
        '1000 - 5000',
        'Greater than 5000',
    ]
    const {
        values,
        setFieldValue,
        setFieldTouched,
        touched,
        errors,
    } = useFormikContext()
    const {
        isOpen,
        highlightedIndex,
        getMenuProps,
        selectedItem,
        getToggleButtonProps,
        getItemProps,
    } = useSelect({
        items: options,
        selectedItem: values[name],
        onSelectedItemChange: ({ selectedItem }) => {
            setFieldValue(name, selectedItem)
        },
        onIsOpenChange: ({ isOpen }) => {
            !isOpen && !touched[name] && setFieldTouched(name)
        },
    })
    const showErr = touched[name] && errors[name]
    return (
        <DropdownWrapper>
            <InputContainer>
                <Input
                    primary
                    type="text"
                    style={{ paddingRight: '32px' }}
                    value={selectedItem || ''}
                    {...getToggleButtonProps({
                        onBlur: () => {
                            setFieldTouched(name)
                        },
                    })}
                    onChange={() => {
                        return true
                    }}
                    readOnly={false}
                />
                <InputContent primary>{header}</InputContent>
                {showErr && (
                    <>
                        <InputErrorIcon>
                            <ErrorIcon />
                        </InputErrorIcon>
                        <ErrorMessage>{errors[name]}</ErrorMessage>
                    </>
                )}
                <CancelButton>
                    <EmployeeSizeIcon />
                </CancelButton>
                {!showErr && (
                    <IconRight>
                        <DropdownIcon />
                    </IconRight>
                )}
                <DropdownUlWrapper>
                    <DropdownUl {...getMenuProps()}>
                        {isOpen &&
                            options.map((option, key) => (
                                <DropdownLi
                                    key={key}
                                    {...getItemProps({
                                        item: option,
                                        index: key,
                                        highlight: highlightedIndex === key,
                                    })}
                                >
                                    {option}
                                </DropdownLi>
                            ))}
                    </DropdownUl>
                </DropdownUlWrapper>
            </InputContainer>
        </DropdownWrapper>
    )
}

const UseCaseDropdown = ({ header, name }) => {
    const options = [
        { value: '1', label: 'IT support' },
        { value: '2', label: 'HR support' },
        { value: '3', label: 'Others' },   
    ]
    const {
        values,
        setFieldValue,
        setFieldTouched,
        touched,
        errors,
    } = useFormikContext()
    const {
        isOpen,
        highlightedIndex,
        getMenuProps,
        selectedItem,
        getToggleButtonProps,
        getItemProps,
        itemToString
    } = useSelect({
        items: options,
        itemToString: item => (item ? `${item.value} ${item.label}` : ''),
        selectedItem: values[name],
        onSelectedItemChange: ({ selectedItem }) => {
            console.log("DOING ::: SELECTED ITEM",selectedItem)
            setFieldValue(name, selectedItem.value)
        },
        onIsOpenChange: ({ isOpen }) => {
            !isOpen && !touched[name] && setFieldTouched(name)
        },
    })
    console.log("DOING ::: BEFORE SELECTED ITEM",selectedItem)
    const filteredOptions = options.find(option => option.value === selectedItem)
    const textToShow = filteredOptions ? filteredOptions.label : ''
    const showErr = touched[name] && errors[name]
    return (
        <DropdownWrapper>
            <InputContainer>
                <Input
                    primary
                    type="text"
                    style={{ paddingRight: '32px' }}
                    value={textToShow}
                    {...getToggleButtonProps({
                        onBlur: () => {
                            setFieldTouched(name)
                        },
                    })}
                    onChange={() => {
                        return true
                    }}
                    readOnly={false}
                />
                <InputContent primary>{header}</InputContent>
                {showErr && (
                    <>
                        <InputErrorIcon>
                            <ErrorIcon />
                        </InputErrorIcon>
                        <ErrorMessage>{errors[name]}</ErrorMessage>
                    </>
                )}
                <CancelButton>
                    <EmployeeSizeIcon />
                </CancelButton>
                {!showErr && (
                    <IconRight>
                        <DropdownIcon />
                    </IconRight>
                )}
                <DropdownUlWrapper>
                    <DropdownUl {...getMenuProps()}>
                        {isOpen &&
                            options.map((option, key) => (
                                <DropdownLi
                                    key={key}
                                    {...getItemProps({
                                        item: option,
                                        index: key,
                                        highlight: highlightedIndex === key,
                                    })}
                                >
                                    {option.label}
                                </DropdownLi>
                            ))}
                    </DropdownUl>
                </DropdownUlWrapper>
            </InputContainer>
        </DropdownWrapper>
    )
}

const DisplaySelectedCountry = ({ country, ...containerProps }) => {
    const { name, flag } = country || {
        name: '',
        flag: '',
    }
    return (
        <div className="display_country" {...containerProps}>
            <span>{flag}</span>
            <span>{name}</span>
        </div>
    )
}

const CountryDropDown = ({ header, name }) => {
    const [countries, setCountries] = useState(getList())
    const inputBoxRef = useRef(null)
    const {
        values,
        setFieldValue,
        setFieldTouched,
        touched,
        errors,
    } = useFormikContext()
    const {
        inputValue,
        isOpen,
        highlightedIndex,
        selectedItem,
        getComboboxProps,
        getInputProps,
        getMenuProps,
        getToggleButtonProps,
        getItemProps,
        setInputValue,
    } = useCombobox({
        items: countries,
        selectedItem: values[name],
        onInputValueChange: ({ inputValue }) => {
            setCountries(searchFlag(inputValue || ''))
        },
        onIsOpenChange: ({ isOpen }) => isOpen && setInputValue(''),
        onSelectedItemChange: ({ selectedItem }) => {
            setFieldValue(name, selectedItem)
        },
        itemToString: item => (item ? `${item.flag} ${item.name}` : ''),
    })
    const showErr = touched[name] && errors[name]
    useEffect(() => {
        if (isOpen && inputBoxRef.current) {
            inputBoxRef.current.focus()
        }
    }, [isOpen])
    return (
        <DropdownWrapper {...getComboboxProps()}>
            <InputContainer>
                {/* {!isOpen && <Input
                    primary
                    type="text"
                    style={{ paddingRight: '32px', borderRadius: '6px' }}
                    value={selectedItem ?  `${selectedItem.flag} ${selectedItem.name}`: ''}
                    {...getToggleButtonProps()}
                    // onChange={() => {
                    //     return true
                    // }}
                    readOnly={false}
                />} */}
                {!isOpen && (
                    <DisplaySelectedCountry
                        country={selectedItem}
                        {...getToggleButtonProps()}
                    />
                )}

                <Input
                    primary
                    type="text"
                    {...getInputProps({
                        value: typeof inputValue === 'string' && inputValue,
                        ref: inputBoxRef,
                    })}
                    style={{
                        display: isOpen ? 'block' : 'none',
                        borderRadius: '6px',
                    }}
                    // onFocus={toggleMenu}
                />
                <InputContent primary>{header}</InputContent>
                {showErr && (
                    <>
                        <InputErrorIcon>
                            <ErrorIcon />
                        </InputErrorIcon>
                        <ErrorMessage>{errors[name]}</ErrorMessage>
                    </>
                )}
                <CancelButton>
                    <CountryIcon />
                </CancelButton>
                {!showErr && (
                    <IconRight>
                        <DropdownIcon />
                    </IconRight>
                )}
                <DropdownUlWrapper>
                    <DropdownUl {...getMenuProps()}>
                        {isOpen &&
                            countries.map(({ flag, name, code }, key) => (
                                <DropdownLi
                                    key={key}
                                    {...getItemProps({
                                        item: { flag, name, code },
                                        index: key,
                                        highlight: highlightedIndex === key,
                                    })}
                                >
                                    <div className="country_code_dropdown">
                                        <span>{`${flag}`}</span>
                                        <span>{`${name}`}</span>
                                        <span>{`(${code})`}</span>
                                    </div>
                                    {/* {`${flag} ${name} (${code})`} */}
                                </DropdownLi>
                            ))}
                    </DropdownUl>
                </DropdownUlWrapper>
            </InputContainer>
        </DropdownWrapper>
    )
}

const addPlusIfNot = string => (string.startsWith('+') ? string : `+${string}`)

// const MobileDropdown = ({ header, name }) => {
//     const { values, setFieldValue } = useFormikContext()
//     const [inputCodes, setCodes] = useState(countryCodes)
//     const [inputText, setInputText] = useState('')
//     const {
//         isOpen,
//         inputValue,
//         getComboboxProps,
//         getInputProps,
//         getMenuProps,
//         getItemProps,
//         getToggleButtonProps,
//         highlightedIndex,
//         selectedItem,
//     } = useCombobox({
//         items: inputCodes,
//         inputValue: inputText,
//         selectedItem: values[name],
//         onSelectedItemChange: ({ selectedItem }) => {
//             setFieldValue(name, selectedItem)
//         },
//         onInputValueChange: ({ inputValue }) => {
//             let withPlus = addPlusIfNot(inputValue)
//             setCodes(
//                 countryCodes.filter(code => `+${code}`.startsWith(withPlus))
//             )
//             setInputText(withPlus)
//         },
//     })
//     const inputBoxRef = useRef(null)
//     useEffect(() => {
//         if (isOpen && inputBoxRef.current) {
//             inputBoxRef.current.focus()
//             inputBoxRef.current.select()
//         } else {
//             setCodes(countryCodes)
//             setInputText(selectedItem)
//         }
//     }, [isOpen])
//     return (
//         <DropdownWrapper {...getComboboxProps()}>
//             <InputContainer>
//                 {!isOpen && (
//                     <Input
//                         primary
//                         type="text"
//                         {...getToggleButtonProps()}
//                         value={selectedItem ? `+${selectedItem}` : '+'}
//                         readOnly
//                     />
//                 )}
//                 <Input
//                     primary
//                     type="text"
//                     {...getInputProps({
//                         value: inputValue ? addPlusIfNot(inputValue) : '',
//                         ref: inputBoxRef,
//                     })}
//                     style={{ display: isOpen ? 'block' : 'none' }}
//                 // onFocus={toggleMenu}
//                 />
//                 <InputContent primary>{header}</InputContent>
//                 {/* <CancelButton
//                     style={{
//                         width: '34px',
//                         display: 'flex',
//                         alignItems: 'center',
//                     }}
//                 >
//                     <div className="fflag fflag-BJ ff-md"></div>
//                 </CancelButton> */}
//                 <RightDropdownArrow>
//                     <NextIcon />
//                 </RightDropdownArrow>
//                 <DropdownUlWrapper>
//                     <DropdownUl {...getMenuProps()}>
//                         {isOpen &&
//                             inputCodes.map((countryCode, index) => (
//                                 <DropdownLi
//                                     key={`${countryCode}`}
//                                     {...getItemProps({
//                                         item: countryCode,
//                                         index,
//                                         highlight: highlightedIndex === index,
//                                     })}
//                                 >
//                                     {/* <div className="fflag fflag-BJ ff-md"></div> */}
//                                     <span>+{countryCode}</span>
//                                 </DropdownLi>
//                             ))}
//                     </DropdownUl>
//                 </DropdownUlWrapper>
//             </InputContainer>
//         </DropdownWrapper>
//     )
// }

const DisplaySelectedDialCode = ({ flag, dial_code, ...containerProps }) => {
    return (
        <div className="display_dialCode" {...containerProps}>
            <span>{flag}</span>
            <span>{dial_code}</span>
        </div>
    )
}

const MobileDropdown = ({ header, name }) => {
    const { values, setFieldValue } = useFormikContext()
    const [countries, setCountries] = useState(getList())
    const currentItem = useMemo(
        () => findFlagByDialCode(values[name].dial_code),
        [values[name].dial_code]
    )
    const {
        isOpen,
        inputValue,
        getComboboxProps,
        getInputProps,
        getMenuProps,
        getItemProps,
        getToggleButtonProps,
        highlightedIndex,
        selectedItem,
        setInputValue,
    } = useCombobox({
        items: countries,
        selectedItem: currentItem,
        onSelectedItemChange: ({ selectedItem }) => {
            setFieldValue(name, selectedItem)
        },
        onInputValueChange: ({ inputValue }) => {
            setCountries(searchFlag(inputValue || ''))
        },
        itemToString: item => (item ? `${item.flag} ${item.dial_code}` : ''),
        onIsOpenChange: ({ isOpen }) => isOpen && setInputValue(''),
    })
    const inputBoxRef = useRef(null)
    useEffect(() => {
        if (isOpen && inputBoxRef.current) {
            inputBoxRef.current.focus()
            inputBoxRef.current.select()
        } else {
            setCountries(getList())
        }
    }, [isOpen])
    return (
        <DropdownWrapper {...getComboboxProps()}>
            <InputContainer>
                {/* {!isOpen &&  (
                    <Input
                        primary
                        type="text"
                        {...getToggleButtonProps()}
                        value={selectedItem ? `${selectedItem.flag} ${selectedItem.dial_code}` : '+'}
                        readOnly
                    />
                )} */}
                {!isOpen && (
                    <DisplaySelectedDialCode
                        flag={selectedItem.flag}
                        dial_code={selectedItem.dial_code}
                        {...getToggleButtonProps()}
                    />
                )}
                <Input
                    primary
                    type="text"
                    {...getInputProps({
                        value: inputValue || '',
                        ref: inputBoxRef,
                    })}
                    style={{ display: isOpen ? 'block' : 'none' }}
                    // onFocus={toggleMenu}
                />
                <InputContent primary>{header}</InputContent>
                {/* <CancelButton
                    style={{
                        width: '34px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <div className="fflag fflag-BJ ff-md"></div>
                </CancelButton> */}
                <RightDropdownArrow>
                    <NextIcon />
                </RightDropdownArrow>
                <DropdownUlWrapper>
                    <DropdownUl className="country_code" {...getMenuProps()}>
                        {isOpen &&
                            countries.map((country, index) => (
                                <DropdownLi
                                    key={country.code}
                                    {...getItemProps({
                                        item: country,
                                        index,
                                        highlight: highlightedIndex === index,
                                    })}
                                >
                                    {/* <div className="fflag fflag-BJ ff-md"></div> */}
                                    <div className="country_code_dropdown">
                                        <span>{country.flag}</span>
                                        <span>{country.name}</span>
                                        <span>{country.dial_code}</span>
                                    </div>
                                </DropdownLi>
                            ))}
                    </DropdownUl>
                </DropdownUlWrapper>
            </InputContainer>
        </DropdownWrapper>
    )
}

const toLowerCaseWithOutSpace = R.compose(
    R.replace(/[\W_]/g, ''),
    R.toLower
)

const submitSignup = values => {
    return axios
        .post(process.env.REACT_APP_AUTH_DIRECT_SIGNUP, values)
        .then(() => {
            window.location =
                process.env.REACT_APP_AUTH_REDIRECT + '?showtour=true'
        })
}

const useToggle = initialValue => {
    const [value, setValue] = useState(initialValue)
    const toggleValue = useCallback(() => {
        setValue(!value)
    }, [value])
    return [value, toggleValue]
}

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

function getCurrentUTCTime() {
    const now = new Date()
    const hour = now
        .getUTCHours()
        .toString()
        .padStart(2, '0')
    const minute = now
        .getUTCMinutes()
        .toString()
        .padStart(2, '0')
    return `${hour}:${minute}`
}

function getCurrentUTCDate() {
    const now = new Date()
    const day = now
        .getUTCDate()
        .toString()
        .padStart(2, '0')
    const month = (now.getUTCMonth() + 1).toString().padStart(2, '0')
    const year = now.getUTCFullYear().toString()
    return `${day}/${month}/${year}`
}

function FormContainer(props) {
    const [turnstileToken, setTurnstileToken] = useState('')
    const submitSignup = values => {
        // return Promise.resolve('success')
        values = {
            ...values,
            phone_code: values['phone_code'].dial_code.slice(1), // slicing to skip "+" character,
            country: `${values['country'].name}`,
        }
        return axios
            .post(process.env.REACT_APP_AUTH_DIRECT_SIGNUP, values, {
                headers: {
                    'cf-turnstile-response': turnstileToken,
                },
            })
            .then(something => {
                // console.log("DOING ::: BEFORE CALLING GA IN THEN")
                lazyGA().event({
                    category: 'Sign up',
                    action: 'sign up success',
                    label: `${toLowerCaseWithOutSpace(values.workspace)}`,
                })
                const utmParams = getUtmParams()
                mixpanel.alias(values.email, mixpanel.get_distinct_id())
                mixpanel.identify(values.email)
                mixpanel.people.set({
                    '$first_name': values.first_name,
                    $last_name: values.last_name,
                    $name: `${values.first_name} ${values.last_name}`,
                    $email: values.email,
                    'Phone Code': values.phone_code,
                    'Phone Number': values.phone_number,
                    'Company Name': values.org,
                    'Company Size': values.company_size,
                    'SignedUp Time': getCurrentUTCTime(),
                    'SignedUp Date': getCurrentUTCDate(),
                    'Selected Country': values.country,
                    Workspace: `${toLowerCaseWithOutSpace(values.workspace)}`,
                    ...utmParams,
                })
                mixpanel.track('Signup', {
                    workspace: `${toLowerCaseWithOutSpace(values.workspace)}`,
                    email: values.email,
                    ...utmParams,
                })
            })
            .then(sleeper(5000))
            .then(props.callbackAfterSignup)
            .catch(err => {
                // console.log("DOING ::: BEFORE CALLING GA IN CATCH")
                lazyGA().event({
                    category: 'Sign up',
                    action: 'sign up failure',
                    label: `${toLowerCaseWithOutSpace(values.workspace)}`,
                })
                mixpanel.track('SignupFailure', {
                    workspace: `${toLowerCaseWithOutSpace(values.workspace)}`,
                })
                console.log('Sign up error', err)
                return Promise.reject(err)
            })
    }

    const [showPassword, togglePassword] = useToggle(false)
    const query = useQuery()
    const email = query.get('email')
    useEffect(() => {
        mixpanel.track('Entered Into Signup page')
    }, [])
    return (
        <>
            <Formik
                initialValues={{
                    ...signupFormSchema.getDefaultFromShape(),
                    email: email || '',
                }}
                onSubmit={submitSignup}
                validationSchema={signupFormSchema}
                validateOnBlur={true}
            >
                {({
                    submitForm,
                    isSubmitting,
                    isValid,
                    validateForm,
                    isValidating,
                    dirty,
                }) => (
                    <>
                        <FormWrapper autoComplete="off">
                            {!isSubmitting ? (
                                <>
                                    <WorkspaceName>
                                        <div className="workspace_input">
                                            <label className="label_top">
                                                assistant.workativ.com/workspace/
                                            </label>
                                        </div>
                                        <CommonInputs
                                            type="text"
                                            placeholder="Workspace Name"
                                            showIcon
                                            inputIcon={<WorkspaceIcon />}
                                            name="workspace"
                                            transform={toLowerCaseWithOutSpace}
                                            errorText={err => {
                                                return typeof err ===
                                                    'object' &&
                                                    err.type ===
                                                        WS_CHECK_FAILURE
                                                    ? err.message
                                                    : err
                                            }}
                                            canShowErr={(touched, err) => {
                                                return (
                                                    (typeof err === 'object' &&
                                                        err.type ===
                                                            WS_CHECK_FAILURE) ||
                                                    (touched && err)
                                                )
                                            }}
                                        />
                                    </WorkspaceName>

                                    <WidthContainer>
                                        <CommonInputs
                                            type="text"
                                            placeholder="First Name"
                                            showIcon
                                            inputIcon={<UserIcon />}
                                            name="first_name"
                                        />
                                        <CommonInputs
                                            type="text"
                                            placeholder="Last Name"
                                            showIcon
                                            inputIcon={<UserIcon />}
                                            name="last_name"
                                        />
                                    </WidthContainer>

                                    <CommonInputs
                                        type="email"
                                        placeholder="Work Email"
                                        showIcon
                                        inputIcon={<EmailICon />}
                                        name="email"
                                        errorText={err => {
                                            return typeof err === 'object' &&
                                                (err.type === BLOCKED_EMAIL ||
                                                    err.type ===
                                                        EXISTING_EMAIL_CHECK_FAILED)
                                                ? err.message
                                                : err
                                        }}
                                        canShowErr={(touched, err) => {
                                            return (
                                                (typeof err === 'object' &&
                                                    (err.type ===
                                                        BLOCKED_EMAIL ||
                                                        err.type ===
                                                            EXISTING_EMAIL_CHECK_FAILED)) ||
                                                (touched && err)
                                            )
                                        }}
                                    />
                                    {/* Password */}
                                    <PasswordWrapper>
                                        <CommonInputs
                                            type={
                                                showPassword
                                                    ? 'text'
                                                    : 'Password'
                                            }
                                            placeholder="Password"
                                            showIcon
                                            inputIcon={<PasswordIcons />}
                                            name="password"
                                            showInfoIcon
                                        />
                                        <PasswordIcon onClick={togglePassword}>
                                            <PasswordHideIcon />
                                        </PasswordIcon>
                                    </PasswordWrapper>

                                    {/* Mobile Number */}
                                    {/* <WidthContainer>
                                    <CountryDropDown
                                            header="Country"
                                            name="country"
                                        />
                                    </WidthContainer> */}
                                    <MobileCodeWrapper>
                                        <CountryDropDown
                                            header="Country"
                                            name="country"
                                        />
                                        <MobileWrapper>
                                            <MobileWrapperLeft>
                                                <MobileDropdown
                                                    header="Code"
                                                    name="phone_code"
                                                />
                                            </MobileWrapperLeft>

                                            <CommonInputs
                                                type="text"
                                                placeholder="Phone Number"
                                                showIcon
                                                inputIcon={<MobileIcon />}
                                                transform={value => {
                                                    return R.test(
                                                        /[0-9]/,
                                                        value[value.length - 1]
                                                    )
                                                        ? value
                                                        : value.slice(
                                                              0,
                                                              value.length - 1
                                                          )
                                                }}
                                                name="phone_number"
                                            />
                                        </MobileWrapper>
                                    </MobileCodeWrapper>
                                    {/* Company name */}
                                    <WidthContainer>
                                        <CommonInputs
                                            type="text"
                                            placeholder="Company Name"
                                            showIcon
                                            inputIcon={<CompanyIcon />}
                                            name="org"
                                        />
                                        <CompanySizeDropdown
                                            header="Company size"
                                            name="company_size"
                                        />
                                    </WidthContainer>
                                    <WidthContainer>
                                        <UseCaseDropdown
                                            header="Use case"
                                            name="use_case"
                                        />
                                        <Turnstile
                                        sitekey="0x4AAAAAAAEiTxQ4CvVQlwOV"
                                        onVerify={token => {
                                            // console.log(token);
                                            setTurnstileToken(token)
                                        }}
                                        onError={error => {
                                            // console.log(token);
                                            console.log('error', error)
                                        }}
                                        onExpire={error => {
                                            // console.log(token);
                                            console.log('error expired', error)
                                        }}
                                    />
                                    </WidthContainer>
                                  
                                    <Paragraph>
                                        By clicking below, you agree to
                                        Workativ’s{' '}
                                        <a
                                            href="https://workativ.com/terms"
                                            target="_blank"
                                            rel="noreferrer noopener"
                                        >
                                            {' '}
                                            Terms of Services
                                        </a>{' '}
                                        and
                                        <a
                                            href="https://workativ.com/privacy"
                                            target="_blank"
                                            rel="noreferrer noopener"
                                        >
                                            {' '}
                                            Privacy Policy.
                                        </a>
                                    </Paragraph>

                                    <SignInWrapper>
                                        <Button
                                            onClick={e => {
                                                !isValidating &&
                                                    isValid &&
                                                    turnstileToken !== '' &&
                                                    submitForm(e)
                                                e.preventDefault()
                                            }}
                                            className={
                                                isValid && turnstileToken !== ''
                                                    ? 'signup_enabled'
                                                    : 'signup_disabled'
                                            }
                                            signup_enabled={
                                                isValid && turnstileToken !== ''
                                                    ? 'signup'
                                                    : null
                                            }
                                        >
                                            <label>Start your FREE Trial</label>
                                        </Button>
                                        <Paragraph>
                                            Already have an account?{' '}
                                            <Link
                                                to={
                                                    process.env
                                                        .REACT_APP_UI_BASE_URL
                                                }
                                            >
                                                <span>Sign in</span>
                                            </Link>
                                        </Paragraph>
                                    </SignInWrapper>
                                </>
                            ) : (
                                <PopupLoader>
                                    <img src={loader} alt="loader" />
                                </PopupLoader>
                            )}
                        </FormWrapper>
                    </>
                )}
            </Formik>
        </>
    )
}

function ContentBox() {
    return (
        <>
            <ContentWrapper>
                <HeaderContent>Start your FREE Bot</HeaderContent>
                <Paragraph>
                    No credit card required. No strings attached.
                </Paragraph>
                <UlWrapper>
                    <HeaderContent>
                        Everything you need for an amazing bot
                    </HeaderContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Easy Setup & On-boarding Included</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Pre-built Chatbots for quick start</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Automate FAQs with Knowledge AI GPT</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Integrate bot with 1000+ App workflows</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>
                            AI-powered Shared Live Chat Inbox for Agents
                        </label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>{' '}
                        <label>Chatbot Templates & App Marketplace </label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Multi-channel Support</label>{' '}
                        <ChannelIcons>
                            <span className="_display_icons">
                                <SlackIconCC />
                                <span className="hover_content">Slack</span>
                            </span>
                            <span className="_display_icons">
                                <TeamsIcon />
                                <span className="hover_content">MS Teams</span>
                            </span>
                            <span className="_display_icons">
                                <WidgetIcon />
                                <span className="hover_content">
                                    Web Chatbot
                                </span>
                            </span>
                        </ChannelIcons>
                    </LiContent>
                </UlWrapper>
                <div className="img_wrapper">
                    <img src={isoLogo} alt="iso_workativ" />
                </div>
            </ContentWrapper>
        </>
    )
}

function SignUpDetials() {
    const isMobile = useMedia(
        // Media queries
        ['(min-width: 320px) and  (max-width: 600px)'],
        // Column counts (relates to above media queries by array index)
        [true],
        // Default column count
        false
    )

    const [showThankyouPopup, setShowThakyouPopup] = useState(false)

    const deskTopCallBack = () => {
        window.location = process.env.REACT_APP_AUTH_REDIRECT + '?showtour=true'
    }

    const mobileCallBack = () => {
        setShowThakyouPopup(true)
    }

    return isMobile ? (
        <GridContainerMobile>
            <MobileHeaderContentWrapper>
                <HeaderContent>Start your FREE Bot</HeaderContent>
                <Paragraph>
                    No credit card required. No strings attached.
                </Paragraph>
            </MobileHeaderContentWrapper>
            <TestiMonialsSignUpMobile />
            <FormContainer callbackAfterSignup={mobileCallBack} />
            <MobileContentWrapper>
                <UlWrapper>
                    <HeaderContent>
                        Everything you need for an amazing bot
                    </HeaderContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Easy Setup & On-boarding Included</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Pre-built Chatbots for quick start</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Automate FAQs with Knowledge AI GPT</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Integrate bot with 1000+ App workflows</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>
                            AI-powered Shared Live Chat Inbox for Agents{' '}
                        </label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>{' '}
                        <label>Chatbot Templates & App Marketplace</label>{' '}
                    </LiContent>
                    <LiContent>
                        <span>
                            <GreenTickIconMarketplace />
                        </span>
                        <label>Multi-channel Support</label>{' '}
                        <ChannelIcons>
                            <span className="_display_icons">
                                <SlackIconCC />
                                <span className="hover_content">Slack</span>
                            </span>
                            <span className="_display_icons">
                                <TeamsIcon />
                                <span className="hover_content">MS Teams</span>
                            </span>
                            <span className="_display_icons">
                                <WidgetIcon />
                                <span className="hover_content">
                                    Web Chatbot
                                </span>
                            </span>
                        </ChannelIcons>
                    </LiContent>
                </UlWrapper>
                <CustomerLogoDiv>
                    <LogosHeader>Join hundred of industry-leaders</LogosHeader>
                    <img
                        className="customer_logo"
                        src={customerLogoMob}
                        alt="customers"
                    />
                </CustomerLogoDiv>
                <IsoLogo>
                    <img src={isoMob} alt="iso_workativ" />
                </IsoLogo>
            </MobileContentWrapper>
            {showThankyouPopup == true ? (
                <MobileOverlay>
                    <MobileOverlayContent>
                        <ThankyouWrapper>
                            <ContentWithPadding>
                                <ThankyouImageWrapper>
                                    <ThumbsUpSvg />
                                </ThankyouImageWrapper>
                                <HeaderContent>
                                    Thank you for signing up
                                </HeaderContent>
                                <Paragraph>
                                    Please continue in desktop to complete your
                                    onboarding.
                                </Paragraph>
                            </ContentWithPadding>
                        </ThankyouWrapper>
                    </MobileOverlayContent>
                </MobileOverlay>
            ) : null}
        </GridContainerMobile>
    ) : (
        <>
            {' '}
            <TestiMonialsSignUp />
            <GridContainer>
                <ContentBox />

                <div className="form_wrapper">
                    <FormContainer callbackAfterSignup={deskTopCallBack} />
                </div>
            </GridContainer>
            <CustomerLogoDiv>
                <h3 className="heading_customer_logo">
                    Join hundreds of industry-leaders
                </h3>
                <img src={customerLogo}></img>
            </CustomerLogoDiv>
        </>
    )
}

function Header() {
    return (
        <>
            <ImageWrapper>
                <Logo src={logo} alt="Assistant" />
            </ImageWrapper>
        </>
    )
}
function TestiMonialsSignUp() {
    return (
        <TestimonialsDiv>
            <FirstReview>
                <img className="capterra_logo" src={capterraLogo}></img>
                <img className="capterra_star_image" src={starImage}></img>
                <img className="capterra_star_image" src={starImage}></img>
                <img className="capterra_star_image" src={starImage}></img>
                <img className="capterra_star_image" src={starImage}></img>
                <img className="capterra_star_image" src={starImage}></img>
                <span>5/5</span>
            </FirstReview>
            <SecondReview>
                <img className="g2_logo" src={g2Logo}></img>
                <img className="g2_star_image" src={starImage}></img>
                <img className="g2_star_image" src={starImage}></img>
                <img className="g2_star_image" src={starImage}></img>
                <img className="g2_star_image" src={starImage}></img>
                <img className="g2_star_image" src={starImage}></img>
                <span>5/5</span>
            </SecondReview>
        </TestimonialsDiv>
    )
}
function TestiMonialsSignUpMobile() {
    return (
        <TestimonialsDivMobile>
            <FirstReviewMobile>
                <img className="capterra_logo_mobile" src={capterraLogo}></img>
                <img className="capterra_star_mobile" src={starImage}></img>
                <img className="capterra_star_mobile" src={starImage}></img>
                <img className="capterra_star_mobile" src={starImage}></img>
                <img className="capterra_star_mobile" src={starImage}></img>
                <img className="capterra_star_mobile" src={starImage}></img>
                <span>5/5</span>
            </FirstReviewMobile>
            <SecondReviewMobile>
                <img className="g2_logo_mobile" src={g2Logo}></img>
                <img className="g2_star_mobile" src={starImage}></img>
                <img className="g2_star_mobile" src={starImage}></img>
                <img className="g2_star_mobile" src={starImage}></img>
                <img className="g2_star_mobile" src={starImage}></img>
                <img className="g2_star_mobile" src={starImage}></img>
                <span>5/5</span>
            </SecondReviewMobile>
        </TestimonialsDivMobile>
    )
}
export function SignUpWrapper() {
    return (
        <Wrapper>
            {/* <BgImage src={signupImg} /> */}

            <Header />

            <SignUpDetials />
        </Wrapper>
    )
}
